module.exports = __webpack_public_path__ + "img/spec_m.b72bfdbb.png";